import { random } from "lodash";
function makeConfetto() {
    var width = Math.random() * 8;
    var height = width * 0.5;
    var colours = [
        "confetti-yellow",
        "confetti-blue",
        "confetti-red",
        "confetti-green"
    ];
    var colour = colours[random(0, colours.length - 1)];
    var confetto = document.createElement("div");
    confetto.style.width = width + "px";
    confetto.style.height = height + "px";
    confetto.style.transform = "rotate(" + Math.random() * 360 + "deg)";
    confetto.classList.add("confetti");
    confetto.classList.add(colour);
    return confetto;
}
export function getConfetti(maxWidth, maxHeight, total) {
    if (total === void 0) { total = 20; }
    return Array
        .from(Array(total), function (v, index) { return index; })
        .map(function (index) {
        var confetto = makeConfetto();
        var tiltX = random(0, 60, true) * (index % 2 === 0 ? 1 : -1);
        var startX = random(0, maxWidth, true);
        var endX = startX + tiltX;
        var startY = random(10, 100, true) * -1;
        var endY = maxHeight + random(100, 200, true);
        return {
            confetto: confetto,
            startX: startX,
            endX: endX,
            startY: startY,
            endY: endY
        };
    });
}
export function fireConfetti(container, confetti) {
    return confetti.map(function (_a) {
        var confetto = _a.confetto, startX = _a.startX, endX = _a.endX, startY = _a.startY, endY = _a.endY;
        confetto.style.top = startY + "px";
        confetto.style.left = startX + "px";
        confetto.addEventListener("transitionend", function () {
            if (confetto.parentNode) {
                confetto.parentNode.removeChild(confetto);
            }
        });
        container.appendChild(confetto);
        return window.setTimeout(function () {
            confetto.style.top = endY + "px";
            confetto.style.left = endX + "px";
        }, random(0, 3000));
    });
}
